import React from 'react'
import FeatureMain from '../../../../components/Features/FeatureMain/FeatureMain'
import { ProjectBranch } from '../../../../components/Features/projectBranch'
import { pageData } from './pageData'

export default function Ings20260721Feature({
    projectBranch,
}: {
    projectBranch: ProjectBranch
}) {
    return <FeatureMain {...pageData} projectBranch={projectBranch} />
}
